import { render } from "./BackgroundImage.vue?vue&type=template&id=e2635dda&scoped=true"
import script from "./BackgroundImage.vue?vue&type=script&lang=js"
export * from "./BackgroundImage.vue?vue&type=script&lang=js"

import "./BackgroundImage.vue?vue&type=style&index=0&id=e2635dda&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src771272295/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2635dda"]])

export default __exports__